import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TravelService } from 'src/app/service/travel.service';
import { getFromLocalStorage, setToLocalStorage } from 'src/app/shared/helpers';

@Component({
  selector: 'app-insurance-type-edit',
  templateUrl: './insurance-type-edit.component.html',
  styleUrls: ['./insurance-type-edit.component.scss']
})
export class InsuranceTypeEditComponent implements OnInit {
  formAlias: string;
  editModeMap = {};
  form: FormGroup;
  currency: string;
  currencyData: any;
  constructor(protected fb: FormBuilder, private service: TravelService) { }

  ngOnInit(): void {
    this.formAlias = 'PolicyType';
    this.form = this.fb.group({
      covid: [''],
      currency: [this.insurance.currency],
      franchise: [''],
      policy: ['premium']
    });
    this.form.patchValue(this.formData);
    this.form.controls['currency'].setValue(this.insurance.currency);
    this.currencyData = JSON.parse(localStorage.getItem('insurance'));
  }

  get insurance(): any {
    return JSON.parse(localStorage.getItem('insurance'));
  }

  onEdit(index: number) {
    this.editModeMap[index] = true;
  }

  done(index: number) {
    this.editModeMap[index] = false;
    if (this.form.valid) {
      this.currencyData.currency = this.form.controls['currency'].value;
      setToLocalStorage('policy', this.formAlias, this.form.value);
      localStorage.setItem('insurance', JSON.stringify(this.currencyData));
      setToLocalStorage('calculate', 'withCovid', this.form.get('covid').value);
      setToLocalStorage('calculate', 'travelFranchiseTypeId', this.form.get('franchise').value ? 1 : 2);
      this.service.calculateAgain();
    }
  }

  get policy(): any {
    return JSON.parse(localStorage.getItem('policy'));
  }

  get formData() {
    const formValue = getFromLocalStorage('policy');
    return formValue && formValue[this.formAlias] ? formValue[this.formAlias] : {} && new Date(parseInt(localStorage.getItem('policy')));
  }

}
